import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { bannerReducer } from './banner/reducer';
import * as bannerActions from './banner/actions';
import { useAppContext } from './AppContext';
import { useStateWithActions } from './utils';
import { PERIOD } from '../../constants/enrollment';

export const BannerContext = React.createContext();
BannerContext.displayName = 'BannerContext';

export const BannerContextProvider = ({ children }) => {
    const {
        staff: { id: staffUid },
        bmWindow: { period, startDate },
    } = useAppContext();
    const initState = () => JSON.parse(sessionStorage.getItem(staffUid)) || {};
    const [actions, state] = useStateWithActions(bannerActions, bannerReducer, {}, initState);

    const isSummerPeriodAvailable = () => {
        const isSummerPeriod = period === PERIOD.SUMMER;
        const currentDate = new Date();

        return isSummerPeriod && currentDate >= startDate;
    };

    const isBannerVisible = (classId, studentUid, flagName) =>
        get(state, [classId, studentUid, flagName], true);

    const isBannerAvailable = (classId, studentUid, flagName) =>
        get(state, [classId, studentUid, flagName], false);

    const getBannerProperty = (classId, studentUid, propName) =>
        get(state, [classId, studentUid, propName], []);

    useEffect(() => {
        sessionStorage.setItem(staffUid, JSON.stringify(state));
    }, [staffUid, state]);

    return (
        <BannerContext.Provider
            value={{
                actions,
                ...state,
                isBannerVisible,
                isBannerAvailable,
                getBannerProperty,
                isSummerPeriodAvailable,
            }}
        >
            {children}
        </BannerContext.Provider>
    );
};

BannerContextProvider.propTypes = {
    children: PropTypes.node,
};

BannerContextProvider.defaultProps = {
    children: null,
};

export default BannerContextProvider;

// helper function

export const useBannerContext = () => React.useContext(BannerContext);
